import React, { useEffect, useState } from 'react';

const Awards = () => {
  const [awards, setAwards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/awards.json')
      .then(res => {
        if (!res.ok) throw new Error('Failed to load awards data');
        return res.json();
      })
      .then(setAwards)
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <section className="resume-awards"><p>Loading...</p></section>;
  if (error) return <section className="resume-awards"><p>Error: {error}</p></section>;

  return (
    <section className="resume-awards">
      <h2>Awards</h2>
       <ul style={{listStyle: 'none', padding: 0}}>
        {awards.map((award, idx) => (
           <li key={idx} style={{marginBottom: '18px'}}>
            <div className="project-item">
              <h3 key={idx}>{award}</h3>
            </div>
            </li>
        ))}
      </ul>
    </section>
  );
};

export default Awards;
